var exports = {
  "n": "x93eb46d8--3cee4d--link",
};

module.exports = exports;
